import Services from '../../services';
export const getCredit = async () => {
  try {
    const result = await Services.getCredit();
    const cartablist = result.mainBusinessAmountSrvs.filter((a) => a?.cartable == true);
    let list = [];
    list = cartablist.map((val) => ({
      name: val?.guildSrv?.name,
      label: val?.guildSrv?.name,
      value: val?.guildSrv?.code,
      id: val?.guildSrv?.code,
    }));
    return list;
  } catch (error) {}
};
